import { render } from "./HeroiconsOutlineChartPie.vue?vue&type=template&id=05c7f2b9"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChartPie.vue"]])

export default __exports__